var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ZAfont_family ZAfont_size"},[_vm._v(_vm._s(_vm.$t('1447')))])])}
var staticRenderFns = []

export { render, staticRenderFns }